import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  simpleWorkflowAltText: {
    id: 'repository.pullRequest.mergeChecks.mergeChecksEmptyState.simpleWorkflowAltText',
    description:
      'Alt text for the simple workflow image in the empty state when there are no merge checks set up for a repository.',
    defaultMessage: 'Simple workflow illustration',
  },
  emptyStateDescriptionFirst: {
    id: 'repository.pullRequest.mergeChecks.mergeChecksEmptyState.descriptionFirst',
    description:
      'First line of description for the empty state when there are no merge checks set up for a repository.',
    defaultMessage:
      "It looks like you don't have merge checks set up in your target branch yet.",
  },
  emptyStateDescriptionSecond: {
    id: 'repository.pullRequest.mergeChecks.mergeChecksEmptyState.descriptionSecond',
    description:
      'Second line of description for the empty state when there are no merge checks set up for a repository.',
    defaultMessage:
      "Recommend or require that pull requests meet certain condition before merging by using what's provided or creating your own, for example, a specific number of approvals or passing builds.",
  },
  setupMergeChecks: {
    id: 'repository.pullRequest.mergeChecks.mergeChecksEmptyState.setupMergeChecks',
    description:
      'Link text to set up merge checks for a repository in the empty state.',
    defaultMessage: 'Set up merge checks',
  },
  setupCustomChecks: {
    id: 'repository.pullRequest.mergeChecks.mergeChecksEmptyState.setupCustomChecks',
    description:
      'Link text to set up custom checks for a repository in the empty state.',
    defaultMessage: 'Set up custom checks',
  },
});
